// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2wBSi","info":"UpdateTermsInfo_info__t-jdE"};